import PrefixEnum from '../prefixes'

export default Object.freeze({
    'pureflow.gymondo.fitness': PrefixEnum.PURE_FLOW,
})
